import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@material-ui/core';
import PropTypes from 'prop-types';

import { IsEmpty } from '../../common/checks';
import MText from '../common/MText';

const ContriPoiHeader = (props) => (
  <div className="d-flex flex-row justify-content-start align-items-center content-header pt-3 pb-2">
    <Link to="/admin/contriPois" title="Back to list" className="d-flex align-items-center">
      <Icon className="back">arrow_back</Icon>
    </Link>

    <MText size={22} text={!IsEmpty(props.contriPoi) ? props.contriPoi.name : 'Add POI'} />
  </div>
);

ContriPoiHeader.propTypes = {
  contriPoi: PropTypes.shape(Object).isRequired,
};

export default ContriPoiHeader;
